import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
//import { snapToArray } from "../helper";

/*
  Generated class for the UserProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UserProvider {

  private user: AngularFirestoreCollection<any>;

  constructor(
    public firestore: AngularFirestore
  ) {
    this.user = firestore.collection<any>('users');
    //console.log('Hello UserProvider Provider');
  }

  postUserDevice(device_id, preferenceUser, gendereUser) {
    return this.user.ref.doc(device_id).get().then((snap: any) => {
      if (!snap.exists) {
        this.user.doc(device_id).set({
          email: "",
          first_name: "",
          last_name: "",
          username: "",
          preference: preferenceUser,
          overage: "18",
          UID: "",
          reading: [],
          photo: "default",
          gender: gendereUser
        }).catch((error) => {
          console.log(error);
        });
      } else {
        this.user.doc(device_id).update({
          preference: preferenceUser,
          gender: gendereUser
        }).catch((error) => {
          console.log(error);
        });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts